import { render, staticRenderFns } from "./RentObjectChannels.vue?vue&type=template&id=1044ac0e&scoped=true&lang=pug"
import script from "./RentObjectChannels.vue?vue&type=script&lang=js"
export * from "./RentObjectChannels.vue?vue&type=script&lang=js"
import style0 from "./RentObjectChannels.vue?vue&type=style&index=0&id=1044ac0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044ac0e",
  null
  
)

export default component.exports